import React from "react";
import { Navigate } from "react-router-dom";
import { isAdmin } from "../api/auth";

function ProtectedRoute({ children }) {
  return isAdmin() ? children : <Navigate to="/admin/login" />;
}

export default ProtectedRoute;
